import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsys.company.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-lpsys-company-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsys.company.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysCompanyItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    @Input() main: any;
    @Input() company_id: any;
    @Input() menu: any;

    public company: any = null;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        if (this.company_id == "new") {
            this.company = { extra: {}, isnew: true };
            await this.service.render();
            return;
        }
        const { data } = await wiz.call("info", { id: this.company_id });
        this.company = data;

        if (!this.company.id) this.company.registed_number = this.company_id;
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public linkCompanyMenu(menu: string) {
        return `/company/${this.main}/${this.company_id}/${menu}`;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 rounded-md bg-zinc-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-blue-600";
        }
        return "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600";
    }
}

export default PortalLpsysCompanyItemComponent;